import React from 'react';
import FeedbackCanvas from "../../components/canvas/FeedbackCanvas";
import { WebsocketContextProvider } from '../../context/WebsocketContextProvider';
import AuthenticatedLayout from "../../layout/AuthenticatedLayout";
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../stores/hooks';
import { RootState } from '../../stores/store';

const FeedbackCanvasRender = (): React.JSX.Element => {
  const sessionStore = useAppSelector((state: RootState) => state.session);
  const { id } = useParams()

  if (!id) return <></>

  return (
    <AuthenticatedLayout>
      {
        sessionStore.id && sessionStore.id !== '' &&
        <WebsocketContextProvider cognitoToken={sessionStore.id_token} feedbackCanvasId={id} userId={sessionStore.id}>
          <FeedbackCanvas />
        </WebsocketContextProvider>
      }
    </AuthenticatedLayout>
  );
}

export default FeedbackCanvasRender;
